import '@djx/observable';
import 'simplebar';

import MainController from './controllers/main';

import { isDesktop, isIOS, isTouch } from './utils/useragent';

document.body.classList.add(isDesktop() ? 'is-desktop' : 'is-mobile');
document.cookie = `doj_touchDevice=${isTouch()}; path=/`;

if(isIOS()) {
  document.body.classList.add('is-ios');
}

const mainController = new MainController();

const setCssVars = () => {
  document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  document.documentElement.style.setProperty('--app-100-vh', `${window.innerHeight}px`);
  document.documentElement.style.setProperty('--app-50-vh', `${window.innerHeight * 0.5}px`);
  document.documentElement.style.setProperty('--app-75-vh', `${window.innerHeight * 0.75}px`);
}

window.addEventListener('resize', () => setCssVars());

window.addEventListener('DOMContentLoaded', () => {
  mainController.initDynamicInclude();
  mainController.init();

  (document.querySelector('.o-roomle-iframe iframe') as HTMLElement | null)?.focus();

  // comply backdrop
  let complyAppInitialized = localStorage.getItem('complyConsentManager__madeDecision') !== null ? JSON.parse(localStorage.getItem('complyConsentManager__madeDecision') || '0') : false;

  const removeClass = () => {
    setTimeout(() => {
      document.querySelector('#comply-consent-manager')?.classList.remove('comply-open');
    }, 290);
  };

  const handleDOMNodeInserted = (e: any) => {
    if (!complyAppInitialized) {
      const el = e.target;
      if (el.classList.contains('comply-Menu')) {
        document.querySelector('#comply-consent-manager')?.classList.add('comply-open');
        complyAppInitialized = true;
      }
    } else {
      document.removeEventListener('DOMNodeInserted', handleDOMNodeInserted)
    }

    document.querySelector('.comply-AcceptAllButton')?.addEventListener('click', removeClass);
    document.querySelector('.comply-SaveSettingsButton')?.addEventListener('click', removeClass);
  };

  const handleManualOpening = () => {
    setTimeout(() => {
      document.querySelector('.comply-AcceptAllButton')?.addEventListener('click', removeClass);
      document.querySelector('.comply-SaveSettingsButton')?.addEventListener('click', removeClass);
    }, 290);

    const complyContainer = document.querySelector('#comply-consent-manager');
    const openClass = 'comply-open';
    if (!complyContainer) return;
    if (!complyContainer.classList.contains(openClass)) {
      complyContainer.classList.add(openClass);
    } else {
      setTimeout(() => {
        complyContainer.classList.remove(openClass);
      }, 290);
    }
  }

  document.querySelector('.comply-MenuLauncher')?.addEventListener('click', handleManualOpening);
  document.querySelector('a[href="#open-consent-manager"]')?.addEventListener('click', handleManualOpening);

  document.addEventListener('DOMNodeInserted', handleDOMNodeInserted);
});

// All next lines triggers the preloader/spash screen on the home page only
const elPreloader = document.querySelector('#js-preloader')
const needPreload = elPreloader && !window.sessionStorage.getItem('preloader')
if (needPreload === true) {
  elPreloader?.classList.add('is-playable');
  window.sessionStorage.setItem('preloader', 'played');
}

setTimeout(() => {
  document.body.classList.add('is-played');
  if(document.body.classList.contains('is--homepage')) {
    document.body.classList.add('is-loaded');
    document.body.classList.remove('not-loaded');
    window.dispatchEvent(new Event('resize'));
  }
// }, needPreload ? 500 : (window.innerWidth < 768 ? 2250 : 0));
}, needPreload ? 500 : 0);

if(!document.body.classList.contains('is--homepage')) {
  setTimeout(()=>{
    document.body.classList.add('is-loaded');
    document.body.classList.remove('not-loaded');
    window.dispatchEvent(new Event('resize'));
  }, 300);
}
